import { cx } from "@emotion/css";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { htmlFormatter } from "src/formatters/htmlFormatter";
import { useFontSize } from "src/hooks/useFontSize";
import { useMark } from "src/hooks/useMark";

interface FlashcardCardProps {
	front: string;
	back: string;
	query?: string;
	actions?: ReactNode;
	footer?: ReactNode;
}

/** Karta fiszki (przód / tył) — tylko odczyt; akcje opcjonalnie z prawej. */
export function FlashcardCard({
	front,
	back,
	query,
	actions,
	footer,
}: FlashcardCardProps) {
	const { t } = useTranslation();
	const { fontSizeDeepClass } = useFontSize();
	const markRef = useMark<HTMLDivElement>(query ?? "", {
		className: "deck-preview-mark",
	});

	return (
		<div
			ref={markRef}
			className="flashcards-list-element flashcards-list-element--outlined"
		>
			<div className="flashcards-list-element--content">
				<div className="flex flex-col gap-4 pb-12 border-bottom-1">
					<span className="flashcards-list-element--side-label">
						{t("decks.front", "Przód")}
					</span>
					<div
						className={cx(
							fontSizeDeepClass,
							"clear-fix size-16 text-black flashcards-list-element--images",
						)}
					>
						{htmlFormatter(front)}
					</div>
				</div>
				<div className="flex flex-col gap-4 pt-4">
					<span className="flashcards-list-element--side-label">
						{t("decks.back", "Tył")}
					</span>
					<div
						className={cx(
							fontSizeDeepClass,
							"clear-fix size-16-light text-black flashcards-list-element--images",
						)}
					>
						{htmlFormatter(back)}
					</div>
				</div>
				{footer && (
					<div className="flashcards-list-element--footer flex items-center flex-wrap gap-8">
						{footer}
					</div>
				)}
			</div>
			{actions && (
				<div className="flashcards-list-element--icon-actions">{actions}</div>
			)}
		</div>
	);
}
